<template>
  <el-main> 
      <b-row>
          <b-col lg="4" class="my-1"> 
              <b-form-group
                  label="考试项目"
                                 
                  class="mb-0"
                >
                        <b-input-group size="sm">
                              <b-form-select v-model="sel_xm" :options="xmList"
                              value-field="xmname"
                              text-field="xmname"
                              ></b-form-select>
                              <b-input-group-append>
                              <b-button @click="handleoneStudentScore">下一步</b-button>
                              </b-input-group-append>
                        </b-input-group>     
                </b-form-group>     
                      
            </b-col>  
    </b-row>  
  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          xmList: [],
          currentRow: null,
          status:false,
          title:'hello world',
          schoolList:[],
          selXmName:'',
          selSchool:'',
          selClass:'',
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
          st_kaohao: '',
          st_name: '',
          st_school:'',
          st_class:'',
          sel_row_index:0,
          dankeArray: [],
          sel_xm:'',
          isshow:false,

         };
  },
  	 activated() {
      console.log('我这个页面显示就会执行成绩查询页面');
      axios.get('/cjman?op=exameList').then((res)=>{
              console.log(res)
              this.xmList=res.data;
              this.status=true;
              if (this.sel_xm=='')
              {
                this.sel_xm=this.xmList[0]['xmname'];
                console.log('hello');
              }
          }).catch((res)=>{
              console.log(response)
          });

  },
  
  methods: {
          tableRowClassName({ rowIndex }) {
          if (rowIndex % 2 === 0) {
            return "warning-row";
          } else if (rowIndex % 2 === 1) {
            return "success-row";
          }
          return "";
        },       


       handleoneStudentScore () {              
         

                //跳转项目成绩主页
                this.$router.push({

                    name:'cjxmmain',

                    params: { xm:this.sel_xm }

              });

        },



       handleClickImg () {
             axios.get('/cjman?op=oneTizumg', {
                responseType: 'blob' //指定返回数据的格式为blob
            }).then((response)=>{
                console.log(response)
                 var urlCreator = window.URL || window.webkitURL;
								var imageUrl = urlCreator.createObjectURL( response.data );
								this.img_src = imageUrl; 
            }).catch((response)=>{
                console.log(response)
               
            })
       },

  },
}
</script>

<style lang="scss">
    .warning-row {
      background: #142e51;
    }
    .success-row {
      background: #011e47;
    }

  

</style>